import React from 'react';
import './VideoSection.css';

export default function VideoSection() {
  const videos = [
    {
      id: 1,
      title: '🎬 Tanıtım Videomuz',
      subtitle: 'Yeldeğirmeni Eğitim Kurumları’nı daha yakından tanıyın.',
      url: 'https://www.youtube.com/embed/AiG-k_Ic-Dk',
    },
    {
      id: 2,
      title: '🎥 Kampüsümüzden Görüntüler',
      subtitle: 'Öğrencilerimizin eğlenerek öğrendiği ortamı keşfedin.',
      url: 'https://www.youtube.com/embed/4NvHi2nk5PE',
    },
  ];

  return (
    <section className="video-section">
      <h2 className="video-title">🎬 Yeldeğirmeni Tanıtım Videoları</h2>
      <p className="video-subtitle">
        Kurum kültürümüzü, kampüsümüzü ve öğrencilerimizin enerjisini yakından görün!
      </p>

      <div className="video-grid">
        {videos.map((v) => (
          <div className="video-card" key={v.id}>
            <iframe
              src={v.url}
              title={v.title}
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
            <p>{v.subtitle}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
